'use strict';
var klarnaPreferences = window.KPPreferences;
var klarnaPaymentsUrls = window.KlarnaPaymentsUrls;
var klarnaPaymentsResources = window.KPResources;
var klarnaPaymentsConstants = window.KPConstants;
/**
 * build and display error message overlay
 * @param {string} message
 */
function generateErrorAuthMessage (message) {
    setTimeout(function () {
        var msg = message || klarnaPaymentsResources.kpExpressCheckoutAuthFailure;
        if ($('.ec-payment-failure').length === 0) {
            $('body').append(
                '<div class="ec-payment-failure add-to-cart-messages"></div>'
            );
        }
        if ($('.ec-payment-failure-alert').length === 0) {
            $('.ec-payment-failure').append(
                '<div class="alert ' + 'alert-danger' + ' ec-payment-failure-alert add-to-basket-alert text-center" role="alert">'
                + msg + '</div>'
            );
        }
        setTimeout(function () {
            $('.ec-payment-failure-alert').remove();
        }, klarnaPaymentsConstants.ERROR_MSG_ALERT_TIMEOUT);
    }, klarnaPaymentsConstants.KEC_EEROR_WAITTIME);
}
/**
 * Initialize Klarna Express Checkout button
 * @param {Object} container div container element
 * @param {Boolean} isPDP flag for pdp call
 * @param {String} containerId id of the container element
 */
function initKlarnaExpressButton (containerId, isPDP) {
    window.Klarna.Payments.Buttons.init({
        client_id: klarnaPreferences.kpExpressCheckoutClientKey
    }).load({
        container: containerId,
        theme: klarnaPreferences.kpExpressCheckoutTheme,
        shape: klarnaPreferences.kpExpressCheckoutShape,
        locale: klarnaPreferences.kpLocale,
        on_click: (authorize) => {
            // Here you should invoke authorize with the order payload.
            var form = {};
            var url = klarnaPaymentsUrls.generateExpressCheckoutPayload + '?populateAddress=true&isPDP=' + isPDP;
            $.ajax({
                url: url,
                type: 'POST',
                data: form,
                dataType: 'json',
                success: function (data) {
                    if (data.success) {
                        data.payload.merchant_urls = {
                            'authorization': klarnaPaymentsUrls.expressCheckoutAuthCallback
                        };
                        authorize(
                            { collect_shipping_address: data.collectShippingAddress, auto_finalize: false },
                            data.payload,
                            (result) => {
                                if (result.approved) {
                                    $.ajax({
                                        url: klarnaPaymentsUrls.handleExpressCheckoutAuth,
                                        type: 'post',
                                        dataType: 'json',
                                        contentType: 'application/json',
                                        data: JSON.stringify(result),
                                        success: function (data) {
                                            if (data.redirectUrl) {
                                                window.location.href = data.redirectUrl;
                                            }
                                        }
                                    });
                                } else {
                                    generateErrorAuthMessage();
                                }
                            },
                        );
                    } else {
                        if (!data.success && data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (err) {
                    console.log(err);
                }
            });
        },
    },
    // eslint-disable-next-line camelcase
    function load_callback (loadResult) {
        // Here you can handle the result of loading the button
    },
    );
}
window.klarnaAsyncCallback = function () {
    var klarnaExpressCheckoutCart = document.querySelectorAll('.kec-container-cart');
    var klarnaExpressCheckoutMC = document.querySelector('#klarnaExpressCheckoutMC');
    var klarnaExpressCheckoutPDP = document.querySelector('#klarnaExpressCheckoutPDP');
    if (klarnaExpressCheckoutCart.length > 0) {
        klarnaExpressCheckoutCart.forEach(function (element, index) {
            initKlarnaExpressButton('#' + element.dataset.contId, false);
        });
    }
    if (klarnaExpressCheckoutMC) {
        initKlarnaExpressButton('#klarnaExpressCheckoutMC', false);
    }
    if (klarnaExpressCheckoutPDP) {
        initKlarnaExpressButton('#klarnaExpressCheckoutPDP', true);
    }
};
